<mat-nav-list [style.marginTop.px]="isHandset ? 24 : 0">
  @if (isReader || isInstructor || isAllReportsReader) {
    <a
      mat-list-item
      routerLink="/admin"
      [routerLinkActive]="'is-active'"
      (click)="sidenav.close()">
      <mat-icon matListItemIcon>list</mat-icon>
      <span matListItemTitle>Reports list</span>
    </a>
  }
  @if (isReporter || isInstructor || isAllReportsReader) {
    <a
      mat-list-item
      [class.is-active]="router.isActive('/report-form;r', true)"
      (click)="goToNewReport()">
      <mat-icon matListItemIcon>edit_note</mat-icon>
      <span matListItemTitle>New report</span>
    </a>
  }
  @if (isReporter || isInstructor || isAllReportsReader) {
    <a
      mat-list-item
      routerLink="/my-reports"
      [routerLinkActive]="'is-active'"
      (click)="sidenav.close()">
      <mat-icon matListItemIcon>grade</mat-icon>
      <span matListItemTitle>My reports</span>
    </a>
  }
  @if (isReporter || isInstructor || isAllReportsReader) {
    <a
      mat-list-item
      [class.is-active]="router.isActive('/report-form/saved-reports', true)"
      routerLink="/report-form/saved-reports"
      (click)="sidenav.close()">
      <mat-icon matListItemIcon>save</mat-icon>
      <span matListItemTitle>My drafts</span>
    </a>
  }

  @if (isHandset) {
    <a mat-list-item [disabled]="(isOnline$ | async) === false">
      <button
        mat-flat-button
        color="warn"
        [ngClass]="{ isHandset: isHandset }"
        (click)="logout()"
        [disabled]="(isOnline$ | async) === false">
        <mat-icon
          aria-hidden="false"
          aria-label="Logout"
        fontIcon="logout"></mat-icon>
        <span>Logout</span>
      </button>
    </a>
  }
</mat-nav-list>
